<template>
  <v-container>
    <div @click="() => {isExpanded = !isExpanded}">
      <b>{{employ?.firstname}} {{employ?.surname}}</b>
    </div>
    <div v-if="isExpanded" class="bg-light-gray">
      {{JSON.stringify(employ)}}
    </div>
  </v-container>
</template>

<script setup lang="ts">
import {ref} from "vue";

const props = defineProps({
  Employ: { type: Object, required: true }
});

const employ = props.Employ;
const isExpanded = ref(false);

</script>